import { render, staticRenderFns } from "./OrderXs.vue?vue&type=template&id=7551d5d4&scoped=true"
import script from "./OrderXs.vue?vue&type=script&lang=js"
export * from "./OrderXs.vue?vue&type=script&lang=js"
import style0 from "./OrderXs.vue?vue&type=style&index=0&id=7551d5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7551d5d4",
  null
  
)

export default component.exports